import { initInteractiveProducts } from "@opportunus-lib/www/interactive-products/src/interactive-products-init.jsx";

const BASE_IMG_URL = "/www/img/interactive-products/";
const getImg = (img, ext = "png") => `${BASE_IMG_URL}${img}.${ext}`;


if (window.__INITIAL_STATE) {
	initInteractiveProducts({
		zoomIconPath: getImg("zoom"),
		closeBlackIconPath: getImg("close-black"),
		shareIconPath: getImg("share"),
		shoppingCartIcon: getImg("shopping-cart"),

		disableFollowButton: false,

		...window.__INITIAL_STATE,
	});
}
